// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************* Multi Select Dropdown *******/
.multi-selected-items-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .multi-selected-items-container .selected-item p {
    width: unset;
  }
  
  .multi-selected-items-container .remove-item {
    margin: 0px;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: #d3e9e9;
    color: #00a19b;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
  }
  
  .multi-selected-items-container .remove-item span {
    margin-top: 2px;
  }
  
  .multi-selected-items-container .react-dropdown-btn .selected-item p {
    width: 100% !important;
  }
  
  .multi-selected-items-container .additional-items p {
    margin: 0px;
    font-size: 16px;
    font-weight: 600;
    color: #00a19b;
  }
  
  p.placeholderText {
    margin: 0px;
  }
  
  .selected-items-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  
  .react-dropdown .react-dropdown-btn {
    padding-left: 15px;
    padding-right: 15px;
    /* padding-top: 15px; */
    width: 100%;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: 9px;
    background: #fff;
    border: 1px solid #f3f3f3;
  }
  
  .react-dropdown .dropdown-content.drop-up {
    top: auto;
    bottom: 60px;
    transform: translateY(-2px);
  }
  
  .extra-category-dropdown-wrap .react-dropdown .dropdown-content.drop-up {
    top: auto;
    bottom: 40px;
  }
  
  .select-box-wrapper {
    margin-top: 20px;
  }
  
  .select-box-wrapper label {
    font-size: 14px;
    color: #1a1919;
    font-weight: 500;
    margin-bottom: 8px;
    margin-left: 10px;
  }
  
  .extra-drawer-main-wrapper .select-box-wrapper label {
    font-size: 14px;
    color: #1a1919;
    font-weight: 600;
    margin-bottom: 8px;
    margin-left: 10px;
  }
  
  .selected-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 500;
    position: relative;
  }
  
  .react-dropdown-btn .selected-item p {
    max-width: 176px;
    margin: 0px;
    /* padding-top: 10px; */
    font-size: 14px;
    color: #00a19b;
    /* color: #1A1919; */
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .selected-item.placeholderText p {
    color: #1a1919 !important;
  }
  
  .react-dropdown .dropdown-content {
    margin: 0 auto;
    width: 100%;
    cursor: pointer;
    z-index: 9999;
    padding-bottom: 12px;
    border-radius: 9px;
    background: #ffffff;
    position: absolute;
    top: 80;
    left: 0;
    opacity: 1;
    transform: translateY(2px);
    animation: slideIn 0.4s forwards;
    max-height: 50vh;
    overflow: auto;
    border: 1px solid #00a19b;
  }
  
  .dropdown-item.active {
    /* background: #00A19B; */
    border-radius: 8px;
    margin-top: 10px;
  }
  
  .dropdown-item.active .dropdown-options p {
    color: #00a19b !important;
  }

  .dropdown-item:focus, .dropdown-item:hover  .dropdown-options p{
    color: #fff !important;
  }
  
  /* .dropdown-item:focus, .dropdown-item:hover {
      color: #1e2125;
      background-color: #00A19B;
      border-radius: 8px;
  } */
  
  .create-order-dropdown-item:focus,
  .create-order-dropdown-item:hover .dropdown-options p {
    /* color: #fff; */
    color: #00a19b !important;
  }
  
  .select-box-wrapper {
    position: relative;
  }
  
  .react-dropdown .dropdown-content .dropdown-item {
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    gap: 12px;
    font-weight: 500;
    width: 96%;
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }
  
  .dropdown-options {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .dropdown-options img {
    width: 23px;
    height: 22px;
  }
  
  .selected-item img {
    width: 23px;
    height: 22px;
  }
  
  .selected-item.placeholderText img {
    display: none;
  }
  
  .dropdown-selct-tick {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #00a19b;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .react-dropdown label {
    font-size: 22px;
    color: #383838;
    font-weight: 500;
    margin-bottom: 8px;
    margin-left: 25px;
  }
  
  .dropdown-options p {
    font-size: 16px;
    color: #333333 !important;
    font-weight: 400;
    margin: 0px;
  }
  
  .rotate-arrow {
    transform: rotate(180deg) !important;
  }
  
  .selected-item img {
    /* width: 48px;
      height: 24px; */
    width: 35px;
    height: 35px;
    object-fit: cover;
  }
  
  .dropdown-options img {
    width: 36px;
  }
  
  .dropdown-options img {
    /* width: 48px;
      height: 24px; */
    width: 35px;
    height: 35px;
    object-fit: cover;
  }
  
  img.checkdrop-icon {
    width: 19px;
    height: 19px;
  }
  
  .filter-type-heading p {
    font-size: 20px;
    color: #383838;
    font-family: "Roboto";
    font-weight: 500;
    margin-bottom: 0px;
  }
  
  .filter-type-heading {
    padding-top: 20px;
    margin: 0px 30px;
  }
  
  .filter-type-heading.divided-border-line {
    border-top: 1px dashed #ccc;
  }
  
  img.dropdown-down-arrow {
    width: 14px;
  }
  
  img.network-info-icon {
    margin-left: 10px;
    margin-top: -2px;
    cursor: pointer;
  }
  
  .selected-item.placeholderText p {
    color: #626262;
    opacity: 0.5;
  }
  
  .recurring-dropdown-main-wrapper .react-dropdown .react-dropdown-btn {
    height: 42px;
  }
  
  .recurring-dropdown-main-wrapper .react-dropdown-btn .selected-item p {
    padding-top: 0px;
    font-size: 14px;
    /* color: #00A19B; */
  }
  
  .recurring-dropdown-main-wrapper
    .react-dropdown
    .dropdown-content
    .dropdown-item {
    height: 30px;
  }
  
  .error-msg.react-dropdown-btn {
    border: 1px solid #ff0000 !important;
  }
  
  .error-msg.select-box-wrapper label {
    color: #ff0000 !important;
  }
  

 
  div#disabledDropdown {
    opacity: 0.6;
    cursor: no-drop;
  }


  .create-order-dropdown-item:focus, .create-order-dropdown-item:hover {
    background-color: unset !important;
    border-radius: 8px;
}
  
  @media (max-width: 1024px) {
    .react-dropdown-btn .selected-item p {
      font-size: 14px;
    }
  
    img.dropdown-down-arrow {
      width: 14px;
    }
  
    .dropdown-options p {
      font-size: 14px;
    }
  
    .react-dropdown .dropdown-content .dropdown-item {
      height: 42px;
      width: 90%;
    }
  }
  
  /* 
  @media (min-width: 768px) and (max-width: 1024px) {
      .react-dropdown .react-dropdown-btn {
          height: 58px;
      }
  
      .react-dropdown-btn .selected-item p {
          font-size: 16px;
          padding-top: 0px;
      }
  
      img.dropdown-down-arrow {
          width: 14px;
      }
  
      .react-dropdown .dropdown-content .dropdown-item {
          height: 46px;
          width: 92%;
      }
  } */
  
  @media (min-width: 1025px) and (max-width: 1199px) {
    .react-dropdown .react-dropdown-btn {
      height: 58px;
    }
  
    .react-dropdown-btn .selected-item p {
      font-size: 16px;
      padding-top: 0px;
      max-width: 86px;
    }
  
    img.dropdown-down-arrow {
      width: 14px;
    }
  
    .react-dropdown .dropdown-content .dropdown-item {
      height: 46px;
      width: 92%;
    }
  
    .react-dropdown .react-dropdown-btn {
      /* height: 58px; */
      height: 48px;
    }
  
    .react-dropdown-btn .selected-item p {
      /* font-size: 16px; */
      font-size: 12px;
      padding-top: 0px;
    }
  
    img.dropdown-down-arrow {
      width: 11px;
      height: 6px;
    }
  
    .react-dropdown .dropdown-content .dropdown-item {
      height: 46px;
    }
  
    .select-box-wrapper label {
      font-size: 12px;
      margin-bottom: 6px;
    }
  
    .postal-code-option label {
      font-size: 12px !important;
      margin-bottom: 6px;
    }
  
    .react-dropdown .dropdown-content.drop-up {
      top: auto;
      bottom: 48px;
    }
  
    .selected-item img {
      width: 40px;
      height: 20px;
    }
  
    .dropdown-options img {
      width: 40px;
      height: 20px;
      object-fit: cover;
    }
  
    img.checkdrop-icon {
      width: 13px;
      height: 13px;
    }
  
    .dropdown-options p {
      font-size: 14px;
      width: 128px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  
  @media (min-width: 1200px) and (max-width: 1599px) {
    .react-dropdown .react-dropdown-btn {
      /* height: 58px; */
      height: 48px;
    }
  
    .react-dropdown-btn .selected-item p {
      /* font-size: 16px; */
      font-size: 12px;
      padding-top: 0px;
    }
  
    img.dropdown-down-arrow {
      width: 11px;
      height: 6px;
    }
  
    .react-dropdown .dropdown-content .dropdown-item {
      height: 46px;
    }
  
    .select-box-wrapper label {
      font-size: 12px;
      margin-bottom: 6px;
    }
  
    .postal-code-option label {
      font-size: 12px !important;
      margin-bottom: 6px;
    }
  
    .react-dropdown .dropdown-content.drop-up {
      top: auto;
      bottom: 48px;
    }
  
    img.checkdrop-icon {
      width: 13px;
      height: 13px;
    }
  
    .dropdown-options p {
      font-size: 14px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Dashboard/CreateOrder/dropdown/dropdown.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,OAAO;IACP,UAAU;IACV,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;KAIG;;EAEH;;IAEE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE;qBACiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;qBACiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;;;;IAIE,YAAY;EACd;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,YAAY;IACZ,eAAe;EACjB;;;EAGA;IACE,kCAAkC;IAClC,kBAAkB;AACtB;;EAEE;IACE;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,UAAU;IACZ;EACF;;EAEA;;;;;;;;;;;;;;;;;;;KAmBG;;EAEH;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,YAAY;IACd;;IAEA;MACE,qBAAqB;MACrB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,WAAW;IACb;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,YAAY;IACd;;IAEA;MACE,qBAAqB;MACrB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,WAAW;IACb;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/********************* Multi Select Dropdown *******/\n.multi-selected-items-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .multi-selected-items-container .selected-item p {\n    width: unset;\n  }\n  \n  .multi-selected-items-container .remove-item {\n    margin: 0px;\n    width: 19px;\n    height: 19px;\n    border-radius: 50%;\n    background: #d3e9e9;\n    color: #00a19b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n  }\n  \n  .multi-selected-items-container .remove-item span {\n    margin-top: 2px;\n  }\n  \n  .multi-selected-items-container .react-dropdown-btn .selected-item p {\n    width: 100% !important;\n  }\n  \n  .multi-selected-items-container .additional-items p {\n    margin: 0px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #00a19b;\n  }\n  \n  p.placeholderText {\n    margin: 0px;\n  }\n  \n  .selected-items-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n  }\n  \n  .react-dropdown .react-dropdown-btn {\n    padding-left: 15px;\n    padding-right: 15px;\n    /* padding-top: 15px; */\n    width: 100%;\n    height: 62px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-radius: 9px;\n    background: #fff;\n    border: 1px solid #f3f3f3;\n  }\n  \n  .react-dropdown .dropdown-content.drop-up {\n    top: auto;\n    bottom: 60px;\n    transform: translateY(-2px);\n  }\n  \n  .extra-category-dropdown-wrap .react-dropdown .dropdown-content.drop-up {\n    top: auto;\n    bottom: 40px;\n  }\n  \n  .select-box-wrapper {\n    margin-top: 20px;\n  }\n  \n  .select-box-wrapper label {\n    font-size: 14px;\n    color: #1a1919;\n    font-weight: 500;\n    margin-bottom: 8px;\n    margin-left: 10px;\n  }\n  \n  .extra-drawer-main-wrapper .select-box-wrapper label {\n    font-size: 14px;\n    color: #1a1919;\n    font-weight: 600;\n    margin-bottom: 8px;\n    margin-left: 10px;\n  }\n  \n  .selected-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 18px;\n    font-weight: 500;\n    position: relative;\n  }\n  \n  .react-dropdown-btn .selected-item p {\n    max-width: 176px;\n    margin: 0px;\n    /* padding-top: 10px; */\n    font-size: 14px;\n    color: #00a19b;\n    /* color: #1A1919; */\n    font-weight: 500;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  \n  .selected-item.placeholderText p {\n    color: #1a1919 !important;\n  }\n  \n  .react-dropdown .dropdown-content {\n    margin: 0 auto;\n    width: 100%;\n    cursor: pointer;\n    z-index: 9999;\n    padding-bottom: 12px;\n    border-radius: 9px;\n    background: #ffffff;\n    position: absolute;\n    top: 80;\n    left: 0;\n    opacity: 1;\n    transform: translateY(2px);\n    animation: slideIn 0.4s forwards;\n    max-height: 50vh;\n    overflow: auto;\n    border: 1px solid #00a19b;\n  }\n  \n  .dropdown-item.active {\n    /* background: #00A19B; */\n    border-radius: 8px;\n    margin-top: 10px;\n  }\n  \n  .dropdown-item.active .dropdown-options p {\n    color: #00a19b !important;\n  }\n\n  .dropdown-item:focus, .dropdown-item:hover  .dropdown-options p{\n    color: #fff !important;\n  }\n  \n  /* .dropdown-item:focus, .dropdown-item:hover {\n      color: #1e2125;\n      background-color: #00A19B;\n      border-radius: 8px;\n  } */\n  \n  .create-order-dropdown-item:focus,\n  .create-order-dropdown-item:hover .dropdown-options p {\n    /* color: #fff; */\n    color: #00a19b !important;\n  }\n  \n  .select-box-wrapper {\n    position: relative;\n  }\n  \n  .react-dropdown .dropdown-content .dropdown-item {\n    padding: 10px;\n    padding-left: 15px;\n    padding-right: 15px;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 18px;\n    gap: 12px;\n    font-weight: 500;\n    width: 96%;\n    height: 50px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-top: 10px;\n  }\n  \n  .dropdown-options {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .dropdown-options img {\n    width: 23px;\n    height: 22px;\n  }\n  \n  .selected-item img {\n    width: 23px;\n    height: 22px;\n  }\n  \n  .selected-item.placeholderText img {\n    display: none;\n  }\n  \n  .dropdown-selct-tick {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #00a19b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .react-dropdown label {\n    font-size: 22px;\n    color: #383838;\n    font-weight: 500;\n    margin-bottom: 8px;\n    margin-left: 25px;\n  }\n  \n  .dropdown-options p {\n    font-size: 16px;\n    color: #333333 !important;\n    font-weight: 400;\n    margin: 0px;\n  }\n  \n  .rotate-arrow {\n    transform: rotate(180deg) !important;\n  }\n  \n  .selected-item img {\n    /* width: 48px;\n      height: 24px; */\n    width: 35px;\n    height: 35px;\n    object-fit: cover;\n  }\n  \n  .dropdown-options img {\n    width: 36px;\n  }\n  \n  .dropdown-options img {\n    /* width: 48px;\n      height: 24px; */\n    width: 35px;\n    height: 35px;\n    object-fit: cover;\n  }\n  \n  img.checkdrop-icon {\n    width: 19px;\n    height: 19px;\n  }\n  \n  .filter-type-heading p {\n    font-size: 20px;\n    color: #383838;\n    font-family: \"Roboto\";\n    font-weight: 500;\n    margin-bottom: 0px;\n  }\n  \n  .filter-type-heading {\n    padding-top: 20px;\n    margin: 0px 30px;\n  }\n  \n  .filter-type-heading.divided-border-line {\n    border-top: 1px dashed #ccc;\n  }\n  \n  img.dropdown-down-arrow {\n    width: 14px;\n  }\n  \n  img.network-info-icon {\n    margin-left: 10px;\n    margin-top: -2px;\n    cursor: pointer;\n  }\n  \n  .selected-item.placeholderText p {\n    color: #626262;\n    opacity: 0.5;\n  }\n  \n  .recurring-dropdown-main-wrapper .react-dropdown .react-dropdown-btn {\n    height: 42px;\n  }\n  \n  .recurring-dropdown-main-wrapper .react-dropdown-btn .selected-item p {\n    padding-top: 0px;\n    font-size: 14px;\n    /* color: #00A19B; */\n  }\n  \n  .recurring-dropdown-main-wrapper\n    .react-dropdown\n    .dropdown-content\n    .dropdown-item {\n    height: 30px;\n  }\n  \n  .error-msg.react-dropdown-btn {\n    border: 1px solid #ff0000 !important;\n  }\n  \n  .error-msg.select-box-wrapper label {\n    color: #ff0000 !important;\n  }\n  \n\n \n  div#disabledDropdown {\n    opacity: 0.6;\n    cursor: no-drop;\n  }\n\n\n  .create-order-dropdown-item:focus, .create-order-dropdown-item:hover {\n    background-color: unset !important;\n    border-radius: 8px;\n}\n  \n  @media (max-width: 1024px) {\n    .react-dropdown-btn .selected-item p {\n      font-size: 14px;\n    }\n  \n    img.dropdown-down-arrow {\n      width: 14px;\n    }\n  \n    .dropdown-options p {\n      font-size: 14px;\n    }\n  \n    .react-dropdown .dropdown-content .dropdown-item {\n      height: 42px;\n      width: 90%;\n    }\n  }\n  \n  /* \n  @media (min-width: 768px) and (max-width: 1024px) {\n      .react-dropdown .react-dropdown-btn {\n          height: 58px;\n      }\n  \n      .react-dropdown-btn .selected-item p {\n          font-size: 16px;\n          padding-top: 0px;\n      }\n  \n      img.dropdown-down-arrow {\n          width: 14px;\n      }\n  \n      .react-dropdown .dropdown-content .dropdown-item {\n          height: 46px;\n          width: 92%;\n      }\n  } */\n  \n  @media (min-width: 1025px) and (max-width: 1199px) {\n    .react-dropdown .react-dropdown-btn {\n      height: 58px;\n    }\n  \n    .react-dropdown-btn .selected-item p {\n      font-size: 16px;\n      padding-top: 0px;\n      max-width: 86px;\n    }\n  \n    img.dropdown-down-arrow {\n      width: 14px;\n    }\n  \n    .react-dropdown .dropdown-content .dropdown-item {\n      height: 46px;\n      width: 92%;\n    }\n  \n    .react-dropdown .react-dropdown-btn {\n      /* height: 58px; */\n      height: 48px;\n    }\n  \n    .react-dropdown-btn .selected-item p {\n      /* font-size: 16px; */\n      font-size: 12px;\n      padding-top: 0px;\n    }\n  \n    img.dropdown-down-arrow {\n      width: 11px;\n      height: 6px;\n    }\n  \n    .react-dropdown .dropdown-content .dropdown-item {\n      height: 46px;\n    }\n  \n    .select-box-wrapper label {\n      font-size: 12px;\n      margin-bottom: 6px;\n    }\n  \n    .postal-code-option label {\n      font-size: 12px !important;\n      margin-bottom: 6px;\n    }\n  \n    .react-dropdown .dropdown-content.drop-up {\n      top: auto;\n      bottom: 48px;\n    }\n  \n    .selected-item img {\n      width: 40px;\n      height: 20px;\n    }\n  \n    .dropdown-options img {\n      width: 40px;\n      height: 20px;\n      object-fit: cover;\n    }\n  \n    img.checkdrop-icon {\n      width: 13px;\n      height: 13px;\n    }\n  \n    .dropdown-options p {\n      font-size: 14px;\n      width: 128px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  }\n  \n  @media (min-width: 1200px) and (max-width: 1599px) {\n    .react-dropdown .react-dropdown-btn {\n      /* height: 58px; */\n      height: 48px;\n    }\n  \n    .react-dropdown-btn .selected-item p {\n      /* font-size: 16px; */\n      font-size: 12px;\n      padding-top: 0px;\n    }\n  \n    img.dropdown-down-arrow {\n      width: 11px;\n      height: 6px;\n    }\n  \n    .react-dropdown .dropdown-content .dropdown-item {\n      height: 46px;\n    }\n  \n    .select-box-wrapper label {\n      font-size: 12px;\n      margin-bottom: 6px;\n    }\n  \n    .postal-code-option label {\n      font-size: 12px !important;\n      margin-bottom: 6px;\n    }\n  \n    .react-dropdown .dropdown-content.drop-up {\n      top: auto;\n      bottom: 48px;\n    }\n  \n    img.checkdrop-icon {\n      width: 13px;\n      height: 13px;\n    }\n  \n    .dropdown-options p {\n      font-size: 14px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
